// extracted by css-extract-rspack-plugin
export default {"root":"root-kXA9Hj"};